import { values } from 'lodash';
import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { IconStar } from 'sletat-ui-components/lib/SVGIcons/IconStar';
import { ComponentJSSClasses } from './styles';


enum NonStarCategory {
    Apts = 'Apts',
    Villas = 'Villas',
    HV1 = 'HV-1',
    HV2 = 'HV-2'
}

export interface HotelCategoryProps {
    name: string;
    iconWidth?: number;
    iconHeight?: number;
}

interface StyledHotelCategoryProps extends JSSClassesProps<ComponentJSSClasses>, HotelCategoryProps { }

export function HotelCategory(props: StyledHotelCategoryProps) {
    const { classes } = props;

    const isNonStar = (category: string | null): boolean => {
        return values(NonStarCategory).some(c => c === category);
    };

    if (isNonStar(props.name)) {
        return (
            <span>
                {props.name}
            </span>
        );
    }

    return (
        <>
            <span className={classes.hotelCategoryText} >
                {props.name.replace('*', '')}
            </span>
            <IconStar
                width={props.iconWidth || 14}
                height={props.iconHeight || 14}
                fill={'#ffca00'}
            />
        </>
    );
}
